// extracted by mini-css-extract-plugin
export default {"button":"ap-z","reviewSort":"bp-z"};